module.exports = __webpack_public_path__ + "static/documentation-f567bcfc09132cf2a4244f6f1c603322.png";